const fetchAuthenticatedContent = require("./fetchAuthenticatedContent");

module.exports = function saveBookmark(dispatch, user, id, type, bookmarked) {
	// console.warn("saveBookmark", dispatch);
	
	let bookmarks = user.relationships?.field_bookmarks?.data || [];
	if (!bookmarked) {
		bookmarks = [
			...bookmarks,
			{
				type,
				id,
			},
		];
	} else {
		bookmarks = [...bookmarks.filter((item) => item.id != id)];
	}
	let data = {
		type: "user--user",
		id: user.id,
		relationships: { field_bookmarks: { data: [...bookmarks] } },
	};
	return fetchAuthenticatedContent({
		dispatch,
		endpoint: `user/user/${user.id}`,
		method: "PATCH",
		body: {
			data,
		},
	});
};
